var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10172_83171)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#725CE1",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7328 6.56049C19.0919 6.20152 19.5789 5.99991 20.0867 6C20.5944 6.00009 21.0814 6.20189 21.4403 6.56099C21.7993 6.92009 22.0009 7.40709 22.0008 7.91485C22.0007 8.4226 21.7989 8.90952 21.4398 9.26849L20.7068 10.0025L17.9988 7.29449L18.7328 6.56149V6.56049ZM17.2928 8.00149L11.3368 13.9555C11.156 14.1364 11.0198 14.3569 10.9388 14.5995L10.0248 17.3425C9.99538 17.4306 9.99104 17.5251 10.0123 17.6155C10.0336 17.7059 10.0796 17.7886 10.1452 17.8543C10.2108 17.92 10.2934 17.9662 10.3838 17.9876C10.4742 18.009 10.5687 18.0048 10.6568 17.9755L13.3998 17.0605C13.6428 16.9805 13.8628 16.8435 14.0438 16.6625L19.9998 10.7095L17.2918 8.00049L17.2928 8.00149Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10172_83171",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10172_83171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10172_83171",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePencilIcon);
export default __webpack_public_path__ + "static/media/circlePencilIcon.8311f462623bc38ca9867490b7ef4a7b.svg";
export { ForwardRef as ReactComponent };